/**
 * Build a Word-compatible HTML blob and trigger a download.
 * Used from both the Export step and the sidebar quick-download.
 */
export function downloadAsDoc(content, title) {
  if (!content) return false;
  const safeTitle = (title || 'Blog Post').replace(/[<>&"]/g, '');

  const htmlContent = content
    .split(/\n\n+/)
    .map((para) => {
      const trimmed = para.trim();
      if (!trimmed) return '';
      if (trimmed.startsWith('### ')) return `<h3>${trimmed.slice(4).replace(/[<>&"]/g, '')}</h3>`;
      if (trimmed.startsWith('## ')) return `<h2>${trimmed.slice(3).replace(/[<>&"]/g, '')}</h2>`;
      if (trimmed.startsWith('# ')) return `<h1>${trimmed.slice(2).replace(/[<>&"]/g, '')}</h1>`;
      const formatted = trimmed
        .replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
      return `<p>${formatted.replace(/\n/g, '<br/>')}</p>`;
    })
    .join('\n');

  const docHtml = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40">
<head>
<meta charset="utf-8">
<title>${safeTitle}</title>
<style>
  body { font-family: Calibri, Arial, sans-serif; font-size: 12pt; line-height: 1.6; color: #222; }
  h1 { font-size: 22pt; margin: 16pt 0 10pt; color: #1a1a1a; }
  h2 { font-size: 16pt; margin: 14pt 0 8pt; color: #1a1a1a; }
  h3 { font-size: 13pt; margin: 12pt 0 6pt; color: #333; }
  p  { margin: 0 0 10pt; }
  strong { font-weight: bold; }
</style>
</head>
<body>
<h1>${safeTitle}</h1>
${htmlContent}
</body>
</html>`;

  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob(['\ufeff', docHtml], { type: 'application/msword' }));
  a.download = `${(safeTitle.slice(0, 40) || 'blog').replace(/[^\w\s-]/g, '')}.doc`;
  a.click();
  return true;
}
